module.exports = __webpack_public_path__ + "img/avatar-s-23.5e55f949.png";